import { render, staticRenderFns } from "./nearExpireList.vue?vue&type=template&id=1e2c813e"
import script from "./nearExpireList.vue?vue&type=script&lang=js"
export * from "./nearExpireList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports